module.exports = __webpack_public_path__ + "60b103e0a383e1d063cf2f2ac371b58d.svg";